module.exports = __webpack_public_path__ + "static/media/team-03.55c2fde5.jpg";